/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Ctrl_Big2_DescInputs */

const en_mk_ctrl_big2_desc = /** @type {(inputs: Mk_Ctrl_Big2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spec coverage is computed every time the wiki is rebuilt; a cov badge appears on roadmap nodes. When code drifts, the agent proposes a PRD revision — you apply or reject.`)
};

const id_mk_ctrl_big2_desc = /** @type {(inputs: Mk_Ctrl_Big2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cakupan spec dihitung tiap wiki dibangun ulang; badge cov muncul di node roadmap. Saat kode menyimpang, agent mengusulkan revisi PRD — kamu terapkan atau tolak.`)
};

/**
* | output |
* | --- |
* | "Spec coverage is computed every time the wiki is rebuilt; a cov badge appears on roadmap nodes. When code drifts, the agent proposes a PRD revision — you app..." |
*
* @param {Mk_Ctrl_Big2_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_ctrl_big2_desc = /** @type {((inputs?: Mk_Ctrl_Big2_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Ctrl_Big2_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_ctrl_big2_desc(inputs)
	return en_mk_ctrl_big2_desc(inputs)
});